import { TextEditor } from "@spz/ui/components/text-editor";
import type { JSONContent } from "@tiptap/core";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  content: JSONContent;
  onContentChange?: (content: unknown) => void;
};

export const ActivityCommentItemEditing: FC<Props> = ({
  content,
  onContentChange,
}) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      initialContent={content}
      onContentChange={onContentChange}
      canMention={false}
      placeholder={t("activity_comment_no_mention_placeholder")}
      noResultsMessage={t("no_user_found")}
    />
  );
};
